import { ForgotPasswordForm } from "wasp/client/auth";
import { Link as WaspRouterLink, routes } from "wasp/client/router";
import { AuthPageLayout } from "../AuthPageLayout";
import useTranslation from "../../client/hooks/useTranslation";

export function RequestPasswordResetPage() {
  const t = useTranslation();
  return (
    <AuthPageLayout>
      <ForgotPasswordForm appearance={{ colors: { brand: 'hsl(var(--primary))', brandAccent: 'hsl(var(--primary))', submitButtonText: '#ffffff' } }} />
      <br />
      <span className="text-sm font-medium text-gray-900 dark:text-gray-900">
        {t.auth.noAccount}{" "}
        <WaspRouterLink to={routes.SignupRoute.to} className="underline">
          {t.auth.goToSignup}
        </WaspRouterLink>
        .
      </span>
      <br />
      <span className="text-sm font-medium text-gray-900 dark:text-gray-900">
        {t.auth.passwordResetRequested}
      </span>
    </AuthPageLayout>
  );
}
